// extracted by mini-css-extract-plugin
export default {"Badge":"style_Badge__zMPbF","Badge__text":"style_Badge__text__Z9M5P","Badge_withBackground":"style_Badge_withBackground__f5DTu"};